import { render, staticRenderFns } from "./GridContactListItem.vue?vue&type=template&id=281a5d8e"
import script from "./GridContactListItem.vue?vue&type=script&lang=js"
export * from "./GridContactListItem.vue?vue&type=script&lang=js"
import style0 from "./GridContactListItem.vue?vue&type=style&index=0&id=281a5d8e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports